<div class="work-panel-wrapper">
  <div *ngIf="!!getError && standalone" class="container-fluid error-container">
    <div class="col-md-12">{{ getError }}</div>
  </div>
  <div
    #workPanelTitle
    id="work-panel-title-bar"
    *ngIf="hasTitle()"
    [class.minimum-rc-non-ticket-area]="standalone || popOut"
  >
    <div class="specific-panel-title-container">
      <!-- templates are defined in child components, but will render here-->
      <ng-container *ngTemplateOutlet="titleBarRef"></ng-container>
    </div>
    <div class="shared-panel-title-container">
      <div
        id="search-incident"
        class="display-table-cell middle condensed line-sm embed-button"
        *ngIf="canCreateTicket()"
      >
        <app-remote-control-embed-incident
          *ngIf="createAccess()"
          sa-stop-propagation
          [embeddingDisabled]="isActiveRecording() || !isRcRunning"
          (ticketSelected)="associateWithTicket($event)"
        >
        </app-remote-control-embed-incident>
      </div>
    </div>
  </div>

  <app-toast class="toast-bar" [toast]="toast"></app-toast>

  <app-rc-view-v2
    id="work-panel-rc-area"
    [hidden]="!isRcPanelVisible()"
    [rcState]="getCurrentRcState()"
    [standAlone]="standalone"
    [isLicenceActive]="isLicenseActive"
    [popOut]="popOut"
    [isAttachmentEnabled]="isAttachmentEnabled()"
    [currentWorkPanelKey]="workPanelKey"
    [class.minimum-rc-non-ticket-area]="standalone || popOut"
    [snapshotRefreshInProgress]="snapshotRefreshInProgress"
    (menuBarItems)="updateRcMenuBarItems($event)"
    (titleBarRefEvent)="setTitleBar($event, workPanelType.rc)"
    (actionBarRefEvent)="setActionBar($event, workPanelType.rc)"
    (setToastEvent)="setToast($event)"
  >
  </app-rc-view-v2>

  <xs-file-preview
    class="file-preview"
    [hidden]="!isFilePreviewVisible()"
    (attachmentPreviewClosed)="closeWorkPanel($event)"
  ></xs-file-preview>
  <div class="file-preview"></div>
  <xs-snapshot
    [hidden]="!isSnapshotVisible()"
    [isSaveSnapshotEnabled]="isAttachmentEnabled()"
    [isMinimizeButtonVisible]="isMinimizeButtonVisible()"
    [currentWorkPanelKey]="workPanelKey"
    [isPopInOutExternallyDisabled]="isPopInOutIsDisabled()"
    [popOut]="popOut"
    (closeSnapshotEvent)="closeWorkPanel($event)"
    (minimizeSnapshotEvent)="minimizeWorkPanelInitiated()"
    (titleBarRefEvent)="setSnapshotTitleBar($event)"
    (menuBarItems)="updateSnapshotMenuBarItems($event)"
    (actionBarRefEvent)="setActionBar($event, workPanelType.liveSnapshot)"
    [isLicenceActive]="isLicenseActive"
    (setToast)="setToast($event)"
    [titleHeight]="titleHeight"
    (snapshotRefreshInProgress)="onSnapshotRefreshInProgressChanged($event)"
  ></xs-snapshot>

  <div class="work-panel-bars-container rc-bars-container" *ngIf="isRcOrLiveSnapshotVisible()">
    <div class="work-panel-menu-bar">
      <app-work-panel-menu-bar
        class="work-panel-bar-icon"
        [menuBarItems]="menuBarItems"
        [workPanelKey]="workPanelKey"
        [rcState]="null"
        [standAlone]="standalone"
        [collapsible]="isMenuBarCollapsible()"
      ></app-work-panel-menu-bar>
    </div>
    <ng-container *ngTemplateOutlet="actionBarRef"></ng-container>
    <!-- templates are defined in child components, but will render here-->
  </div>
  <div class="splash" *ngIf="isSplashScreenVisible()">
    <div class="splashScreenContainer">
      <div class="splashScreen">
        <img
          class="deviceSplashImage"
          src="assets/images/DeviceImage.svg"
          alt="{{ 'remoteControl_alt_text_devices_splash_screen' | xsI18n }}"
        />
        <div>
          <span class="xsight-body2 text-primary">{{ 'remoteControlSplash_Remote_Control' | xsI18n }}</span>
          <div>
            <span class="xsight-body3 subtext-gray">{{ 'remoteControlSplash_Help' | xsI18n }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showTicketCreate">
  <sa-ticket-create
    [groups]="getGroups()"
    [selectedGroupId]="selectedGroupId"
    (selectGroup)="onGroupSelected($event)"
  ></sa-ticket-create>
</div>
